module.exports = {"653121100":"托克扎克镇","653121101":"兰干镇","653121102":"吾库萨克镇","653121103":"乌帕尔镇","653121201":"塔什米里克乡","653121202":"铁日木乡","653121203":"布拉克苏乡","653121204":"萨依巴格乡","653121205":"站敏乡","653121211":"木什乡","653121400":"县种畜场","653121401":"县园艺场","653121402":"县林场","653121403":"县良种场","653121406":"疏附广州工业城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653121.json
// module id = 3248
// module chunks = 0